import { useQuery } from "@tanstack/react-query";
import { fetchLinkedProjects } from "../services/projectsServices";

export const useLinkedProjects = (projectId) => {
  const { data: linkedProjects, isLoading, isError, refetch} = useQuery({
    queryKey: ["fetchLinkedProjects", projectId],
    queryFn: () => fetchLinkedProjects(projectId),
    enabled: !!projectId,
  });

  return { linkedProjects, isLoading, isError, refetch };
};
